import React, { Component } from 'react'
import StepsListItem from './StepsListItem'
import StepsListHeader from './StepsListHeader'
import styles from '../../styles/common/stepsList.module.css'

export class StepsList extends Component {
    constructor(props) {
        super(props);

        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.current.contains(event.target) && this.props.isOpen) {
            this.props.toggleStepsList(this.props.featureId);
        }
    }

    renderItems() {
        const { isOpen, selectStep, selection, steps, featureId } = this.props;
        if(isOpen) {
            return (
                <div className={styles.container} style={{height: isOpen ? 'auto' : '0px', borderWidth: isOpen ? '1px' : '0px'}}>
                    {steps.map(step => {
                        return <StepsListItem step={step} selection={selection} selectStep={selectStep} featureId={featureId}/>;
                    })}
                </div>
            )
        }
        return null
    }

    getHeader(){
        const { selection, steps } = this.props;
        if(steps.filter((step) => step.id === selection)[0]){        
            return steps.filter((step) => step.id=== selection)[0]
        }else{
            return ''
        }
    }

    getHeadStep() {
        // const { steps, selection } = this.props;
        const { steps } = this.props;
        if(steps.length === 0) return {id: -1, title: "Empty"};
        else return this.getHeader();
    }

    render() {
        const { isOpen, toggleStepsList, featureId } = this.props;
        return (
           <div ref={this.wrapperRef}>
                <StepsListHeader 
                    headStep={this.getHeadStep()}
                    isOpen={isOpen}
                    toggleStepsList={toggleStepsList}
                    featureId={featureId}
                />
                {this.renderItems()}
           </div>
        )
    }
}

export default StepsList
